import { getCompanyStatus, editCompanyInfo } from './company-data';

export const WAIT_INIT_COMPANY = 'WAIT_INIT_COMPANY';
export const INIT_COMPANY_SUCCESS = 'INIT_COMPANY_SUCCESS';
export const INIT_COMPANY_FAIL = 'INIT_COMPANY_FAIL';
export const SAVE_COMPANY_INFO = 'SAVE_COMPANY_INFO';
export const SAVE_COMPANY_INFO_SUCCESS = 'SAVE_COMPANY_INFO_SUCCESS';
export const SAVE_COMPANY_INFO_FAIL = 'SAVE_COMPANY_INFO_FAIL';

export const forwardCompanylList = () => (dispatch) => {
    dispatch({
        type: WAIT_INIT_COMPANY
    });
}

export const initCompanyData = (idToken, companyId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getCompanyStatus(resolve, reject, idToken, companyId);
    });

    doPost
    .then((data) => {        
        dispatch({
            type: INIT_COMPANY_SUCCESS,
            params: {
                companyInfo: data
            }
        });
    })
    .catch((err) => {
        dispatch({
            type: INIT_COMPANY_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });
};

export const saveCompanyInfo = (idToken, bodyObj) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        editCompanyInfo(resolve, reject, idToken, bodyObj);
    });

    doPost
    .then((data) => {
        const msg = data.message;
        if (msg === 'Success') {
            bodyObj['message'] = msg;
            bodyObj['loading'] = false;

            dispatch({
                type: SAVE_COMPANY_INFO_SUCCESS,
                params: {
                    companyInfo: bodyObj,
                    successMsg: 'Save company data complete.'
                }
            });
        } else {
            dispatch({
                type: SAVE_COMPANY_INFO_FAIL,
                params: {
                    errMsg: data.message
                }
            });
        }
    })
    .catch((err) => {
        dispatch({
            type: SAVE_COMPANY_INFO_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: SAVE_COMPANY_INFO
    });
}